export default __webpack_public_path__ + "static/media/Otto.39e2439c.png";